<router-outlet></router-outlet>
<ngx-spinner [fullScreen]="true" template="<img src='../../../../../assets/images2/loader.gif' class='custom_main_loader'/>"></ngx-spinner>
<!-- <div class="custom-loader custom_logo_loader">
  <img src='../../../../../assets/loader.webp' alt="img" loading="lazy" />
</div> -->
 